import { QuestionBankState } from "@/types";
import { createSlice } from "@reduxjs/toolkit";
import { fetchQuestionBankUploadStatus, importXlsx, searchQuestions, universalSearch, upsertQuestions } from "./questionBankThunks";

// Initial state
const initialState: QuestionBankState = {
  questions: [],
  loading: false,
  error: '',
  initialized: false,
  universalQuestions: [],
  currentUpload: null,
  uploadError: '',
}

const questionBankSlice = createSlice({
  name: "questionBank",
  initialState,
  reducers: {
    clearCurrentUpload: (state) => {
      state.currentUpload = null
      state.uploadError = ''
    },
  },
  extraReducers: (builder) => {
    // Handle test initialization
    builder
      .addCase(searchQuestions.pending, (state) => {
        state.loading = true
        state.error = ''
        state.initialized = false;
      })
      .addCase(searchQuestions.fulfilled, (state, action) => {
        state.loading = false
        state.questions = action.payload.questions;
        state.initialized = true;
      })
      .addCase(searchQuestions.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
        state.initialized = true;
      })
    builder
      .addCase(upsertQuestions.pending, (state) => {
        state.loading = true
        state.error = ''
      })
      .addCase(upsertQuestions.fulfilled, (state) => {
        state.loading = false
      })
      .addCase(upsertQuestions.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
    builder
      .addCase(universalSearch.fulfilled, (state, action) => {
        state.universalQuestions = action.payload.questions;
      })
      .addCase(universalSearch.rejected, (state, action) => {
        state.error = action.payload as string
      })
    builder
      .addCase(importXlsx.pending, (state) => {
        state.uploadError = ''
      })
      .addCase(importXlsx.fulfilled, (state, action) => {
        state.currentUpload = action.payload
      })
      .addCase(importXlsx.rejected, (state, action) => {
        state.uploadError = (action.payload as any)?.message || 'Upload failed'
      })
    builder
      .addCase(fetchQuestionBankUploadStatus.fulfilled, (state, action) => {
        // A slower-arriving stale poll (out-of-order response, or one still
        // in flight when the upload was dismissed) must not resurrect it.
        if (state.currentUpload && state.currentUpload.id === action.payload.id) {
          state.currentUpload = action.payload
        }
      })
  },
});

export const { clearCurrentUpload } = questionBankSlice.actions

export default questionBankSlice.reducer
